export enum StickyTabsDeliveryInformation {
    KITCHENS = 'kitchens',
    DOORS = 'doors',
    SINKS = 'sinks',
    APPLIANCES = 'appliances',
    WORKTOPS = 'worktops'
};
